import React from "react";
import { Button, Typography } from "@mui/material";
import { ConfirmationContainer, FormContainer } from "../styles";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Component to display dynamic error messages based on query params or path
 */
function Error() {
  const navigate = useNavigate();
  const location = useLocation();

  // Parse the query string or use path
  const queryParams = new URLSearchParams(location.search);
  const errorType = queryParams.get("error") || location.pathname.split("/").pop();

  // Define error messages based on error type
  const errorMessages = {
    title_issue: {
      title: "Title Issue",
      text: "Title requirements have not been satisfied for turn-in. Contact the HDFS Title department at 866-433-7562 for more information."
    },
    ineligible: {
      title: "Contact Us",
      text: "Based on the completed condition report, you are not eligible for turn-in. Please contact Harley-Davison Financial Services at 800-717-3450 for assistance."
    },
    delinquent_account: {
      title: "Contact Us",
      text: "Please contact Harley-Davidson Financial Services at 800-717-3450 for assistance. Your prompt response is appreciated."
    }
  };

  // Fallback to a default message if the error type is not recognized
  const { title, text } = errorMessages[errorType] || {
    title: "Error",
    text: "An unknown issue has occurred. Please contact customer support for more information."
  };

  return (
    <ConfirmationContainer>
      <FormContainer elevation={3}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>

        <Typography variant="body2" gutterBottom>
          {text}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
          fullWidth
          style={{ marginTop: "20px", padding: "12px 0" }}
          onClick={() => navigate("/")}
        >
          Return
        </Button>
      </FormContainer>
    </ConfirmationContainer>
  );
}

export default Error;
